export default __webpack_public_path__ + "static/7_28-89e55e2f1a43fdef0a0af828361d5fb3.png";